export default __webpack_public_path__ + "static/media/element_31.cc9ef604.webp";